import { fromDom } from "hast-util-from-dom";
import { defaultSchema, sanitize } from "hast-util-sanitize";

const parser = new DOMParser();

export function renderFragmentFromString(html: string) {
  return sanitize(fromDom(parser.parseFromString(html, "text/html")), {
    // biome-ignore lint/style/noNonNullAssertion: <explanation>
    tagNames: [...defaultSchema.tagNames!, "cite", "mark"],
  });
}
